export default __webpack_public_path__ + "static/media/journey-stop-icon.0aace6da.svg";